import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_448: DocMigration = {
  maxSchemaVersion: "0.0.448",
  description: "Normalize the data structure of values stored in parameter value tables",
  apply(json: any) {
    const {
      viewports = {},
      contentTemplateInstances = {},
      planSetTemplateConfigs = {},
      localParameters = {},
      globalParameters = {},
    } = json;

    for (const paramId in localParameters) {
      const param = localParameters[paramId];
      updateParameterType(param);
    }

    for (const paramId in globalParameters) {
      const param = globalParameters[paramId];
      updateParameterType(param);
    }

    for (const viewportId in viewports) {
      const viewport = viewports[viewportId];

      if (viewport.viewType !== "DRAWING") {
        continue;
      }

      normalizeParameterValueTable(viewport.parameterValues ?? {}, localParameters);
    }

    for (const templateId in contentTemplateInstances) {
      const template = contentTemplateInstances[templateId];
      normalizeParameterValueTable(template.parameterValues ?? {}, globalParameters);
    }

    for (const templateId in planSetTemplateConfigs) {
      const template = planSetTemplateConfigs[templateId];
      normalizeParameterValueTable(template.parameterValues ?? {}, localParameters);
      normalizeParameterValueTable(template.globalParameterValues ?? {}, globalParameters);
    }

    return json;
  },
};

function updateParameterType(param: any) {
  if (param.type === "OPTION_CHOICE") {
    param.type = "OPTION";
  }

  if (param.type === "OPTION_PRESET") {
    param.type = "PRESET";
  }

  if (param.type === "CONTENT_SOURCE") {
    switch (param.viewType) {
      case "DRAWING":
        param.type = "DRAWING_TEMPLATE";
        break;
      case "PLAN_VIEW":
        param.type = "LEVEL";
        break;
      case "SECTION_VIEW":
        param.type = "SECTION_VIEW";
        break;
      case "ELEVATION_VIEW":
        param.type = "ELEVATION_VIEW";
        break;
      case "VIEW_3D":
        param.type = "VIEW_3D";
        break;
    }

    delete param.viewType;
  }
}

function normalizeParameterValueTable(parameterValues: { [paramId: string]: any }, parameters: Record<string, any>) {
  for (const paramId in parameterValues) {
    const value = parameterValues[paramId];
    if (value?.type === "PARAMETER_REF") {
      continue;
    }

    const param = parameters[paramId];
    if (!param) {
      // storing as a primitive still allows for parameter evaluation
      parameterValues[paramId] = { type: "PRIMITIVE", value };
      continue;
    }

    parameterValues[paramId] = { type: paramTypeToValueType[param.type], value };
  }
}

const paramTypeToValueType: Record<string, string> = {
  NUMBER: "PRIMITIVE",
  BOOLEAN: "PRIMITIVE",
  DRAWING_SCALE: "PRIMITIVE",
  FOOT_INCH: "PRIMITIVE",
  TEXT: "PRIMITIVE",
  LEVEL: "LEVEL",
  ELEVATION_VIEW: "ELEVATION_VIEW",
  SECTION_VIEW: "SECTION_VIEW",
  VIEW_3D: "PRIMITIVE",
  DRAWING_TEMPLATE: "CONTENT_TEMPLATE",
  PRESET: "OPTION_PRESET",
  OPTION: "OPTION",
  DATA_SEQUENCE: "DATA_SEQUENCE",
  VIEW_TEMPLATE: "VIEW_TEMPLATE",
};

export default migration_0_0_448;
